import React from 'react';

const AbsencesWrapper = ({ component: Component, routeProps }) => (
  <Component {...routeProps} />
);

export default AbsencesWrapper;
